export default __webpack_public_path__ + "img/WF_250MA.30d3c61943fd2d2ff0c04f74b893d707.jpg";